import { toSearchUrl } from './searchConditions.js'

export const useItemIndexPageAction = ({
  conditions,
  isFilterOpen,
  searchFromUrl,
  changeSort,
  changeFilters,
  changePage
}) => {
  const getCurrentInputtedKeyword = () =>
    document.querySelector('.search-form__input--text').value
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  const updateUrl = () => {
    const url = toSearchUrl(conditions)
    history.pushState(url.split('?')[1] || '', '', url)
  }
  const onPopstate = () => searchFromUrl(location.search)

  const onSelectSort = async value => {
    scrollToTop()
    await changeSort(value, getCurrentInputtedKeyword())
    updateUrl()
  }

  const onClickPageLink = async page => {
    scrollToTop()
    await changePage(page)
    updateUrl()
  }

  const onSubmitSearchForm = async (
    lowerBudget,
    higherBudget,
    selectedCategoryIds,
    selectedSceneIds,
    selectedReceivingKindIds
  ) => {
    isFilterOpen.value = false
    await changeFilters(
      {
        lowerBudget,
        higherBudget,
        selectedCategoryIds,
        selectedSceneIds,
        selectedReceivingKindIds
      },
      getCurrentInputtedKeyword()
    )
    updateUrl()
  }

  const onClickItem = ({ id, itemSkuId }) => {
    dataLayer.push({
      event: 'click_item_list__item_detail',
      item_id: id,
      item_sku_id: itemSkuId,
      sort_key: conditions.sortSelectedValue,
      lower_budget: conditions.lowerBudget,
      higher_budget: conditions.higherBudget,
      scene_id: conditions.selectedSceneIds.join(','),
      category_id: conditions.selectedCategoryIds.join(','),
      item_receiving_kinds: conditions.selectedReceivingKindIds.join(','),
      keyword: conditions.keyword
    })
  }

  const onClickItemBox = itemId => {
    dataLayer.push({
      event: 'click_view_history__item',
      via: 'item_list',
      item_id: itemId
    })
  }

  const onClickSectionHeaderLink = () => {
    dataLayer.push({ event: 'click_item_list__view_history_list' })
  }

  return {
    getCurrentInputtedKeyword,
    onPopstate,
    onSelectSort,
    onClickPageLink,
    onSubmitSearchForm,
    onClickItem,
    onClickItemBox,
    onClickSectionHeaderLink
  }
}
